const size = new THREE.Vector2();

function calcInnerCircle(box) {
    const center = new THREE.Vector2();

    box.getSize(size);
    box.getCenter(center);

    return Object.freeze({
        center,
        radius: Math.min(size.x, size.y) * 0.5
    });
}

export default calcInnerCircle;
export { calcInnerCircle };